/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @repo/internal/react/require-jsdoc */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import "./empty-body.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var fixedHeightStyles = null;
export var EmptyViewWithFixedHeight = function EmptyViewWithFixedHeight(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId && "".concat(testId, "--empty-view-with-fixed-height"),
    className: ax(["_4t3i1jdh"])
  }, children);
};
var emptyViewContainerStyles = null;
export var EmptyViewContainer = function EmptyViewContainer(props) {
  var children = props.children,
    testId = props.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId && "".concat(testId, "--empty-view-container"),
    className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"])
  }, children);
};